import { useFocusEffect } from '@react-navigation/native';
import '@reduxjs/toolkit/dist/query';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import React, { useState } from 'react';
import { FlatList, Pressable, StyleSheet, Text, TextInput, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { useTheme } from 'styled-components/native';
import { ProgramType } from 'utils/enum';

import TrackPlayer from '../../components/Radio/player';
import { SEARCH_MENU_OPTION } from './index';

import { Icons } from 'components/Icons';
import SearchVerticalList from 'components/Section/SearchVerticalList';

const Search: React.FC = () => {
  const theme = useTheme();
  const analytics = useAnalytics();
  const [categoryValue, setCategoryValue] = useState<ProgramType>();
  const [searchInputValue, setSearchInputValue] = useState<string>();
  const paddingLeft = useBreakpointValueGS({ xl: 32, lg: 32, base: 15 });

  const pauseRadio = async () => {
    await TrackPlayer.reset();
  };

  useFocusEffect(
    React.useCallback(() => {
      pauseRadio();
    }, [])
  );

  const handleTextInputFocus = () => {
    analytics.triggerSearchStartEvent();
  };

  return (
    <View style={[styles.container, { paddingHorizontal: paddingLeft }]}>
      <View style={[styles.searchBar, { borderColor: theme.colors.base.blue }]}>
        <TextInput
          style={styles.searchInput}
          placeholder="Termos de Pesquisa"
          placeholderTextColor={theme.colors.base.white}
          value={searchInputValue}
          onChangeText={setSearchInputValue}
          onFocus={handleTextInputFocus}
        />

        {!searchInputValue ? (
          <View style={styles.searchIcon}>
            <Icons.MagnifyinGlass />
          </View>
        ) : (
          <Pressable style={styles.clearButton} onPress={() => setSearchInputValue('')}>
            <Icons.Xmark />
          </Pressable>
        )}
      </View>

      <View style={styles.filterContainer}>
        <FlatList
          data={SEARCH_MENU_OPTION}
          keyExtractor={(item) => item.title}
          renderItem={({ item }) => (
            <Pressable
              onPress={() => setCategoryValue(item.value)}
              style={[
                styles.filterButton,
                {
                  borderColor: categoryValue === item.value ? theme.colors.base.blue : '#FFFFFF',
                },
              ]}>
              <Text
                style={[
                  styles.filterButtonText,
                  { color: categoryValue === item.value ? theme.colors.base.blue : '#FFFFFF' },
                ]}>
                {item.title}
              </Text>
            </Pressable>
          )}
          contentContainerStyle={{ height: 40 }}
          showsHorizontalScrollIndicator={false}
          horizontal
        />
      </View>
      <SearchVerticalList searchInputValue={searchInputValue} categoryValue={categoryValue} />
    </View>
  );
};

export default Search;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgba(22, 18, 51, 0.5)',
    paddingVertical: 5,
    marginBottom: 25,
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 2,
    borderRadius: 5,
    width: '100%',
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  searchInput: {
    color: 'white',
    marginLeft: 10,
    flex: 1,
    fontSize: 16,
  },
  searchIcon: {
    marginRight: 10,
  },
  clearButton: {
    marginRight: 5,
  },
  filterContainer: {
    marginTop: 10,
    marginBottom: 15,
  },
  filterButton: {
    overflow: 'hidden',
    padding: 10,
    marginRight: 10,
    borderWidth: 2,
    borderRadius: 8,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterButtonText: {
    fontSize: 14,
  },
});
